import { toast } from "react-toastify";
import { API_PIEZAS_RESERVADAS } from "../views/MainLayout/components/shared/services/piezasReservadas";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initial = []

export const piezasReservadasReducer = (state = initial, action) => {
    switch(action.type){
        case "piezasReservadas/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchPiezasReservadas = () => async (dispatch) => {
  dispatch({ type: 'loading/set', payload: true })

  try {
    const response = await API_PIEZAS_RESERVADAS.get();
    const data = await response.data;
    dispatch({ type: 'piezasReservadas/fullfilled', payload: data })
  } catch (e) {
    toast.error(setErrorMessage(e))
  } finally {
    dispatch({ type: 'loading/set', payload: false })
  }
};